export default __webpack_public_path__ + "static/media/Toplu_Jandarma_Giris_Bildirimi.10bd659b.xlsx";